import './SrOnly.scss';

export type SrOnlyProps = {
    children: React.ReactNode;
}

export function SrOnly({ children }: SrOnlyProps): JSX.Element {
  return <div className="SrOnly">{children}</div>;
}
